import { Link } from "@/locales/routing"
import { useLoginPopower } from "@/provider/LoginPopowerProvider"
import { useUserStore } from "@/store/useUserStore"
import { forwardRef, ReactNode } from "react"

export enum Permissions {
  "tourist", "user"
}



export const AuthenticationLink = forwardRef<HTMLAnchorElement, any>((
  { permission, ...reset }: any &
  { permission?: Permissions },
  ref
) => {

  return <Authentication
    permission={permission}
    render={(verify) => (
      <Link
        {...reset}
        ref={ref}
        onClick={(ev) => {
          if (!verify()) ev.preventDefault()
        }}
      ></Link>
    )} />
})

type AuthenticationProps = { render: (verify: () => boolean) => ReactNode, permission?: Permissions }
// 事件
export const Authentication = ({ render, permission }: AuthenticationProps) => {
  const isLogined = useUserStore(state => state.isLogined)
  const showPopower = useLoginPopower()

  const fn = () => {
    if (!isLogined && permission !== Permissions.tourist) {
      showPopower()
      return false
    }
    return true
  }

  return <>
    {render(fn)}
  </>
}